
















import Vue from 'vue';
export default Vue.extend({
  name: 'FullscreenError',
  props: {
    text: {
      type: String,
      default: '',
    },
    doneText: {
      type: String,
      required: false,
    },
    refreshText: {
      type: String,
      required: false,
    },
    hideRefreshAction: {
      type: Boolean,
      default: false,
    },
  },
});
